import React, { useEffect } from "react";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import "./App.scss";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AppLayout from "./components/layout/Layout";
import routes from "./Pages/routes";
import { getProfileDetails } from "./redux/slices/profileSlice";
import { useDispatch } from "react-redux";
import AppSecureStorage from "./services/secureStorage";
import { message } from "antd";

const AppContent = () => {
  const storage = new AppSecureStorage();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const oldRole = storage.get("role");
    dispatch(getProfileDetails())
      .unwrap()
      .then((profile) => {
        if (oldRole && oldRole !== profile.role) {
          message.info("Your role has been changed. Please sign in again to continue.");
          setTimeout(() => {
            storage.clearAuthData();
            window.location.replace("/login");
          }, 2000);
        }
      })
      .catch(() => {});
  }, [dispatch, location.pathname, storage]);

  return (
    <>
      <AppLayout routers={routes.routes.map((item) => item)} />
      <ToastContainer />
    </>
  );
};

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
